import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  TravelActivityType,
  TravelFileKind,
  travelFileKindLabel,
  travelFileKindList,
} from '@/module/Travel/Request/model/TravelRequestTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type TravelFileKindSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'> & {
  kinds?: readonly TravelFileKind[];
  activityType: TravelActivityType;
};

export function TravelFileKindSelectControl<T extends FieldValues>(props: TravelFileKindSelectControlProps<T>) {
  const { kinds = travelFileKindList, activityType, ...rest } = props;
  const { t } = useTranslation();
  const options = useMemo(
    () => kinds.map(value => ({ value, label: travelFileKindLabel(t, value, activityType) })),
    [kinds, activityType, t],
  );

  return (
    <EnumSelectControl
      {...rest}
      options={options}
    />
  );
}
